export interface AdminUser {
  id: number
  name: string
  email: string
  date: string
  orders: number
  spent: string
  status: string
  subscription: string | null
  lastLogin: string
  country: string
  phone: string
  consultations: number
  lastOrder: string
  notes: string
  riskFlag: string | null
  isVip: boolean
  hasComplaints: boolean
  hasActiveChats: boolean
  hasPaymentIssues: boolean
}

export interface AdminAstrologer {
  id: number
  name: string
  email: string
  spec: string
  rating: number
  reviews: number
  orders: number
  earnings: string
  status: string
  verified: boolean
  badge: string | null
}

export const initialUsers: AdminUser[] = [
  {
    id: 1,
    name: 'Анна Ковалёва',
    email: 'anna@example.com',
    date: '12 Окт 2024',
    orders: 5,
    spent: '12 450 ₽',
    status: 'active',
    subscription: 'Plus',
    lastLogin: '2 часа назад',
    country: 'Россия',
    phone: '+7 (999) 123-45-67',
    consultations: 2,
    lastOrder: '10 Окт 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: true,
    hasPaymentIssues: false,
  },
  {
    id: 2,
    name: 'Иван Петров',
    email: 'ivan.p@gmail.com',
    date: '10 Окт 2024',
    orders: 2,
    spent: '3 980 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '1 день назад',
    country: 'Россия',
    phone: '+7 (916) 234-56-78',
    consultations: 0,
    lastOrder: '08 Окт 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 3,
    name: 'Мария Соколова',
    email: 'm.sokolov@ya.ru',
    date: '08 Окт 2024',
    orders: 8,
    spent: '24 920 ₽',
    status: 'active',
    subscription: 'Pro',
    lastLogin: '5 часов назад',
    country: 'Россия',
    phone: '+7 (903) 345-67-89',
    consultations: 3,
    lastOrder: '07 Окт 2024',
    notes: 'VIP клиент',
    riskFlag: null,
    isVip: true,
    hasComplaints: false,
    hasActiveChats: true,
    hasPaymentIssues: false,
  },
  {
    id: 4,
    name: 'Дмитрий Орлов',
    email: 'd.orlov@mail.ru',
    date: '05 Окт 2024',
    orders: 1,
    spent: '1 990 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '3 дня назад',
    country: 'Украина',
    phone: '+380 (67) 456-78-90',
    consultations: 0,
    lastOrder: '05 Окт 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 5,
    name: 'Елена Козлова',
    email: 'elena.k@yandex.ru',
    date: '01 Окт 2024',
    orders: 12,
    spent: '45 000 ₽',
    status: 'active',
    subscription: 'Pro',
    lastLogin: '1 час назад',
    country: 'Россия',
    phone: '+7 (925) 567-89-01',
    consultations: 5,
    lastOrder: '30 Сен 2024',
    notes: 'VIP клиент',
    riskFlag: null,
    isVip: true,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 6,
    name: 'Алексей Новиков',
    email: 'alex.n@gmail.com',
    date: '28 Сен 2024',
    orders: 0,
    spent: '0 ₽',
    status: 'blocked',
    subscription: null,
    lastLogin: '2 недели назад',
    country: 'Россия',
    phone: '+7 (977) 678-90-12',
    consultations: 0,
    lastOrder: '—',
    notes: 'Заблокирован за мошенничество',
    riskFlag: 'мошенничество',
    isVip: false,
    hasComplaints: true,
    hasActiveChats: false,
    hasPaymentIssues: true,
  },
  {
    id: 7,
    name: 'Ольга Морозова',
    email: 'olga.m@mail.ru',
    date: '25 Сен 2024',
    orders: 3,
    spent: '8 500 ₽',
    status: 'active',
    subscription: 'Plus',
    lastLogin: '12 часов назад',
    country: 'Беларусь',
    phone: '+375 (29) 789-01-23',
    consultations: 1,
    lastOrder: '20 Сен 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: true,
    hasPaymentIssues: false,
  },
  {
    id: 8,
    name: 'Сергей Волков',
    email: 's.volkov@ya.ru',
    date: '20 Сен 2024',
    orders: 6,
    spent: '18 200 ₽',
    status: 'active',
    subscription: 'Pro',
    lastLogin: '6 часов назад',
    country: 'Россия',
    phone: '+7 (915) 890-12-34',
    consultations: 2,
    lastOrder: '18 Сен 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 9,
    name: 'Наталья Лебедева',
    email: 'nat.leb@gmail.com',
    date: '18 Сен 2024',
    orders: 2,
    spent: '5 000 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '4 дня назад',
    country: 'Казахстан',
    phone: '+7 (701) 901-23-45',
    consultations: 1,
    lastOrder: '15 Сен 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 10,
    name: 'Андрей Семёнов',
    email: 'andrey.s@mail.ru',
    date: '15 Сен 2024',
    orders: 4,
    spent: '11 000 ₽',
    status: 'active',
    subscription: 'Plus',
    lastLogin: '1 день назад',
    country: 'Россия',
    phone: '+7 (926) 012-34-56',
    consultations: 0,
    lastOrder: '12 Сен 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 11,
    name: 'Татьяна Егорова',
    email: 'tanya.e@yandex.ru',
    date: '12 Сен 2024',
    orders: 9,
    spent: '32 000 ₽',
    status: 'active',
    subscription: 'Pro',
    lastLogin: '3 часа назад',
    country: 'Россия',
    phone: '+7 (905) 123-45-67',
    consultations: 4,
    lastOrder: '10 Сен 2024',
    notes: 'VIP клиент',
    riskFlag: null,
    isVip: true,
    hasComplaints: false,
    hasActiveChats: true,
    hasPaymentIssues: false,
  },
  {
    id: 12,
    name: 'Павел Кузнецов',
    email: 'pavel.k@gmail.com',
    date: '10 Сен 2024',
    orders: 1,
    spent: '2 500 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '1 неделя назад',
    country: 'Россия',
    phone: '+7 (916) 234-56-78',
    consultations: 0,
    lastOrder: '10 Сен 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 13,
    name: 'Екатерина Попова',
    email: 'katya.p@mail.ru',
    date: '08 Сен 2024',
    orders: 7,
    spent: '21 500 ₽',
    status: 'active',
    subscription: 'Plus',
    lastLogin: '8 часов назад',
    country: 'Россия',
    phone: '+7 (903) 345-67-89',
    consultations: 2,
    lastOrder: '06 Сен 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: true,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 14,
    name: 'Максим Соловьёв',
    email: 'max.s@ya.ru',
    date: '05 Сен 2024',
    orders: 0,
    spent: '0 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '2 недели назад',
    country: 'Грузия',
    phone: '+995 (555) 456-78-90',
    consultations: 0,
    lastOrder: '—',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 15,
    name: 'Юлия Виноградова',
    email: 'yulia.v@gmail.com',
    date: '01 Сен 2024',
    orders: 15,
    spent: '55 000 ₽',
    status: 'active',
    subscription: 'Pro',
    lastLogin: '30 мин назад',
    country: 'Россия',
    phone: '+7 (925) 567-89-01',
    consultations: 6,
    lastOrder: '29 Авг 2024',
    notes: 'VIP клиент, топ покупатель',
    riskFlag: null,
    isVip: true,
    hasComplaints: false,
    hasActiveChats: true,
    hasPaymentIssues: false,
  },
  {
    id: 16,
    name: 'Роман Фёдоров',
    email: 'roman.f@mail.ru',
    date: '28 Авг 2024',
    orders: 3,
    spent: '9 000 ₽',
    status: 'blocked',
    subscription: null,
    lastLogin: '1 месяц назад',
    country: 'Россия',
    phone: '+7 (977) 678-90-12',
    consultations: 1,
    lastOrder: '25 Авг 2024',
    notes: 'Конфликтный клиент',
    riskFlag: 'конфликтный',
    isVip: false,
    hasComplaints: true,
    hasActiveChats: false,
    hasPaymentIssues: true,
  },
  {
    id: 17,
    name: 'Виктория Белова',
    email: 'vika.b@yandex.ru',
    date: '25 Авг 2024',
    orders: 4,
    spent: '14 000 ₽',
    status: 'active',
    subscription: 'Plus',
    lastLogin: '2 дня назад',
    country: 'Россия',
    phone: '+7 (903) 111-22-33',
    consultations: 1,
    lastOrder: '22 Авг 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 18,
    name: 'Артём Михайлов',
    email: 'artem.m@gmail.com',
    date: '20 Авг 2024',
    orders: 2,
    spent: '6 500 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '5 дней назад',
    country: 'Россия',
    phone: '+7 (916) 444-55-66',
    consultations: 0,
    lastOrder: '18 Авг 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
  {
    id: 19,
    name: 'Ирина Васильева',
    email: 'irina.v@mail.ru',
    date: '15 Авг 2024',
    orders: 11,
    spent: '38 000 ₽',
    status: 'active',
    subscription: 'Pro',
    lastLogin: '4 часа назад',
    country: 'Россия',
    phone: '+7 (925) 777-88-99',
    consultations: 3,
    lastOrder: '12 Авг 2024',
    notes: 'VIP клиент',
    riskFlag: null,
    isVip: true,
    hasComplaints: false,
    hasActiveChats: true,
    hasPaymentIssues: false,
  },
  {
    id: 20,
    name: 'Денис Козлов',
    email: 'denis.k@ya.ru',
    date: '10 Авг 2024',
    orders: 1,
    spent: '3 900 ₽',
    status: 'active',
    subscription: null,
    lastLogin: '1 неделя назад',
    country: 'Россия',
    phone: '+7 (977) 000-11-22',
    consultations: 0,
    lastOrder: '10 Авг 2024',
    notes: '',
    riskFlag: null,
    isVip: false,
    hasComplaints: false,
    hasActiveChats: false,
    hasPaymentIssues: false,
  },
]

export const initialAstrologers: AdminAstrologer[] = [
  {
    id: 1,
    name: 'Мария Звёздная',
    email: 'm.star@astro.ru',
    spec: 'Натальная астрология',
    rating: 4.9,
    reviews: 156,
    orders: 89,
    earnings: '445 000 ₽',
    status: 'active',
    verified: true,
    badge: 'top',
  },
  {
    id: 2,
    name: 'Алексей Лунный',
    email: 'a.moon@astro.ru',
    spec: 'Ведическая астрология',
    rating: 4.8,
    reviews: 120,
    orders: 67,
    earnings: '335 000 ₽',
    status: 'active',
    verified: true,
    badge: 'pro',
  },
  {
    id: 3,
    name: 'Елена Солнцева',
    email: 'e.sun@astro.ru',
    spec: 'Таро',
    rating: 4.7,
    reviews: 98,
    orders: 54,
    earnings: '270 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 4,
    name: 'Дмитрий Космос',
    email: 'd.cosmos@astro.ru',
    spec: 'Прогнозирование',
    rating: 4.6,
    reviews: 85,
    orders: 42,
    earnings: '210 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 5,
    name: 'Анна Небесная',
    email: 'a.sky@astro.ru',
    spec: 'Совместимость',
    rating: 4.5,
    reviews: 72,
    orders: 38,
    earnings: '190 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 6,
    name: 'Сергей Планетный',
    email: 's.planet@astro.ru',
    spec: 'Натальная астрология',
    rating: 4.4,
    reviews: 60,
    orders: 30,
    earnings: '150 000 ₽',
    status: 'active',
    verified: false,
    badge: null,
  },
  {
    id: 7,
    name: 'Ольга Зодиак',
    email: 'o.zodiac@astro.ru',
    spec: 'Нумерология',
    rating: 4.3,
    reviews: 45,
    orders: 25,
    earnings: '125 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 8,
    name: 'Иван Астров',
    email: 'i.astrov@astro.ru',
    spec: 'Human Design',
    rating: 4.2,
    reviews: 38,
    orders: 20,
    earnings: '100 000 ₽',
    status: 'active',
    verified: false,
    badge: null,
  },
  {
    id: 9,
    name: 'Наталья Стелла',
    email: 'n.stella@astro.ru',
    spec: 'Детская астрология',
    rating: 4.8,
    reviews: 92,
    orders: 48,
    earnings: '240 000 ₽',
    status: 'active',
    verified: true,
    badge: 'pro',
  },
  {
    id: 10,
    name: 'Павел Орион',
    email: 'p.orion@astro.ru',
    spec: 'Бизнес-астрология',
    rating: 4.1,
    reviews: 30,
    orders: 15,
    earnings: '75 000 ₽',
    status: 'pending',
    verified: false,
    badge: null,
  },
  {
    id: 11,
    name: 'Светлана Венера',
    email: 's.venus@astro.ru',
    spec: 'Астрология отношений',
    rating: 4.7,
    reviews: 88,
    orders: 52,
    earnings: '260 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 12,
    name: 'Андрей Марс',
    email: 'a.mars@astro.ru',
    spec: 'Прогнозирование',
    rating: 4.0,
    reviews: 25,
    orders: 12,
    earnings: '60 000 ₽',
    status: 'active',
    verified: false,
    badge: null,
  },
  {
    id: 13,
    name: 'Екатерина Юпитер',
    email: 'e.jupiter@astro.ru',
    spec: 'Ведическая астрология',
    rating: 4.6,
    reviews: 70,
    orders: 35,
    earnings: '175 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 14,
    name: 'Максим Сатурн',
    email: 'm.saturn@astro.ru',
    spec: 'Натальная астрология',
    rating: 4.3,
    reviews: 42,
    orders: 22,
    earnings: '110 000 ₽',
    status: 'blocked',
    verified: true,
    badge: null,
  },
  {
    id: 15,
    name: 'Юлия Нептун',
    email: 'y.neptune@astro.ru',
    spec: 'Таро',
    rating: 4.5,
    reviews: 55,
    orders: 28,
    earnings: '140 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 16,
    name: 'Роман Плутон',
    email: 'r.pluto@astro.ru',
    spec: 'Хиромантия',
    rating: 4.2,
    reviews: 35,
    orders: 18,
    earnings: '90 000 ₽',
    status: 'active',
    verified: false,
    badge: null,
  },
  {
    id: 17,
    name: 'Татьяна Уран',
    email: 't.uran@astro.ru',
    spec: 'Матрица Судьбы',
    rating: 4.4,
    reviews: 48,
    orders: 24,
    earnings: '120 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 18,
    name: 'Виктор Меркурий',
    email: 'v.mercury@astro.ru',
    spec: 'Руны',
    rating: 4.1,
    reviews: 28,
    orders: 14,
    earnings: '70 000 ₽',
    status: 'pending',
    verified: false,
    badge: null,
  },
  {
    id: 19,
    name: 'Алина Луна',
    email: 'a.luna@astro.ru',
    spec: 'Ленорман',
    rating: 4.6,
    reviews: 65,
    orders: 32,
    earnings: '160 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
  {
    id: 20,
    name: 'Ольга Захарова',
    email: 'o.zakharova@mail.ru',
    spec: 'Нумерология',
    rating: 4.6,
    reviews: 30,
    orders: 25,
    earnings: '75 000 ₽',
    status: 'active',
    verified: true,
    badge: null,
  },
]

export const createInitialOrders = (
  users: AdminUser[],
  astrologers: AdminAstrologer[],
) => {
  return Array.from({ length: 20 }).map((_, i) => ({
    id: `ORD-${1042 - i}`,
    client: users[i % users.length].name,
    email: users[i % users.length].email,
    service: [
      'Консультация (Видео)',
      'Соляр 2024',
      'Натальная карта',
      'Синастрия',
      'Таро-расклад',
    ][i % 5],
    astrologer: astrologers[i % 20].name,
    amount: ['5 000 ₽', '1 990 ₽', '3 900 ₽', '2 500 ₽', '1 500 ₽'][i % 5],
    status:
      i < 3
        ? 'in_progress'
        : i === 5
          ? 'cancelled'
          : i === 7
            ? 'refunded'
            : 'completed',
    date: `${Math.max(1, 15 - i)} Окт 2024`,
    payment: i === 5 ? 'refunded' : i === 7 ? 'failed' : 'paid',
  }))
}

export const createInitialTickets = (users: AdminUser[]) => {
  return Array.from({ length: 10 }).map((_, i) => ({
    id: `TKT-${200 + i}`,
    user: users[i % users.length].name,
    subject: [
      'Проблема с оплатой',
      'Вопрос по отчёту',
      'Жалоба на астролога',
      'Возврат средств',
      'Техническая проблема',
    ][i % 5],
    status: i < 3 ? 'open' : i < 6 ? 'in_progress' : 'closed',
    priority: i < 2 ? 'high' : i < 5 ? 'medium' : 'low',
    date: `${15 - i} Окт 2024`,
  }))
}

export const createInitialReviews = (
  users: AdminUser[],
  astrologers: AdminAstrologer[],
) => {
  return Array.from({ length: 15 }).map((_, i) => ({
    id: i + 1,
    user: users[i % users.length].name,
    astrologer: astrologers[i % 20].name,
    rating: [5, 4, 5, 3, 5, 4, 2, 5, 4, 5, 3, 5, 4, 5, 1][i],
    text: [
      'Отличная консультация!',
      'Хороший астролог',
      'Всё понравилось',
      'Средне',
      'Супер!',
    ][i % 5],
    status: i < 5 ? 'pending' : 'approved',
    date: `${15 - i} Окт 2024`,
  }))
}

export const initialComplaints = [
  {
    id: 1,
    user: 'Алексей Новиков',
    astrologer: 'Мария Звёздная',
    reason: 'Некачественная консультация',
    status: 'open',
    date: '14 Окт 2024',
  },
  {
    id: 2,
    user: 'Екатерина Попова',
    astrologer: 'Иван Астров',
    reason: 'Грубое общение',
    status: 'in_progress',
    date: '12 Окт 2024',
  },
  {
    id: 3,
    user: 'Роман Фёдоров',
    astrologer: 'Павел Орион',
    reason: 'Мошенничество',
    status: 'open',
    date: '10 Окт 2024',
  },
  {
    id: 4,
    user: 'Наталья Лебедева',
    astrologer: 'Андрей Марс',
    reason: 'Задержка отчёта',
    status: 'resolved',
    date: '08 Окт 2024',
  },
  {
    id: 5,
    user: 'Дмитрий Орлов',
    astrologer: 'Максим Сатурн',
    reason: 'Неточный прогноз',
    status: 'open',
    date: '05 Окт 2024',
  },
  {
    id: 6,
    user: 'Анна Ковалёва',
    astrologer: 'Роман Плутон',
    reason: 'Попытка увода клиента',
    status: 'in_progress',
    date: '03 Окт 2024',
  },
]

export const initialRefunds = [
  {
    id: 1,
    orderId: 'ORD-1035',
    user: 'Алексей Новиков',
    amount: '5 000 ₽',
    reason: 'Некачественная услуга',
    status: 'pending',
    date: '14 Окт 2024',
  },
  {
    id: 2,
    orderId: 'ORD-1028',
    user: 'Роман Фёдоров',
    amount: '3 900 ₽',
    reason: 'Отмена клиентом',
    status: 'approved',
    date: '10 Окт 2024',
  },
  {
    id: 3,
    orderId: 'ORD-1020',
    user: 'Дмитрий Орлов',
    amount: '1 990 ₽',
    reason: 'Техническая ошибка',
    status: 'pending',
    date: '05 Окт 2024',
  },
  {
    id: 4,
    orderId: 'ORD-1015',
    user: 'Павел Кузнецов',
    amount: '2 500 ₽',
    reason: 'Двойная оплата',
    status: 'completed',
    date: '01 Окт 2024',
  },
]

export const initialVerificationQueue = [
  {
    id: 1,
    name: 'Павел Орион',
    email: 'p.orion@astro.ru',
    spec: 'Бизнес-астрология',
    submitted: '12 Окт 2024',
    documents: 3,
    status: 'pending',
  },
  {
    id: 2,
    name: 'Виктор Меркурий',
    email: 'v.mercury@astro.ru',
    spec: 'Руны',
    submitted: '10 Окт 2024',
    documents: 2,
    status: 'pending',
  },
  {
    id: 3,
    name: 'Новый Астролог',
    email: 'new@astro.ru',
    spec: 'Таро',
    submitted: '08 Окт 2024',
    documents: 4,
    status: 'review',
  },
  {
    id: 4,
    name: 'Тестовый Астролог',
    email: 'test@astro.ru',
    spec: 'Натальная астрология',
    submitted: '05 Окт 2024',
    documents: 1,
    status: 'pending',
  },
]

export const initialAdRequests = [
  {
    id: 'AD-001',
    advertiser: 'AstroShop',
    type: 'Баннер',
    placement: 'Главная',
    budget: '50 000 ₽',
    status: 'active',
    date: '01 Окт 2024',
  },
  {
    id: 'AD-002',
    advertiser: 'MoonCalendar',
    type: 'Нативная',
    placement: 'Блог',
    budget: '25 000 ₽',
    status: 'pending',
    date: '05 Окт 2024',
  },
  {
    id: 'AD-003',
    advertiser: 'TarotPro',
    type: 'Попап',
    placement: 'Каталог',
    budget: '35 000 ₽',
    status: 'active',
    date: '08 Окт 2024',
  },
]

export const createInitialSubscriptions = (users: AdminUser[]) => {
  return Array.from({ length: 15 }).map((_, i) => ({
    id: i + 1,
    user: users[i % users.length].name,
    plan: i % 3 === 0 ? 'Pro' : 'Plus',
    status: i < 12 ? 'active' : 'cancelled',
    startDate: `${15 - i} Сен 2024`,
    nextPayment: `${15 - i} Окт 2024`,
    amount: i % 3 === 0 ? '990 ₽/мес' : '490 ₽/мес',
  }))
}

export const initialCampaigns = [
  {
    id: 1,
    name: 'Осенний дайджест',
    subject: 'Звёзды октября',
    recipients: '2 450',
    sent: '2 380',
    opened: '42%',
    clicked: '12%',
    date: '10 Окт 2024',
    status: 'sent',
  },
  {
    id: 2,
    name: 'Новые услуги',
    subject: 'Новые астрологи на платформе',
    recipients: '1 800',
    sent: '0',
    opened: '0%',
    clicked: '0%',
    date: '15 Окт 2024',
    status: 'draft',
  },
  {
    id: 3,
    name: 'Промо Pro',
    subject: 'Скидка 30% на Pro подписку',
    recipients: '3 200',
    sent: '3 100',
    opened: '38%',
    clicked: '15%',
    date: '01 Окт 2024',
    status: 'sent',
  },
]

export const initialContentItems = [
  {
    id: 1,
    title: 'Ретроградный Меркурий 2024',
    type: 'Статья блога',
    status: 'Опубликовано',
    date: '12 Окт 2024',
  },
  {
    id: 2,
    title: 'Как читать натальную карту',
    type: 'Страница',
    status: 'Черновик',
    date: '10 Окт 2024',
  },
  {
    id: 3,
    title: 'FAQ по подпискам',
    type: 'FAQ',
    status: 'Опубликовано',
    date: '08 Окт 2024',
  },
  {
    id: 4,
    title: 'Лунный календарь ноябрь',
    type: 'Статья блога',
    status: 'На модерации',
    date: '05 Окт 2024',
  },
]

export const initialPromoCodes = [
  {
    id: 1,
    code: 'AUTUMN2024',
    discount: '20%',
    limit: '100',
    used: 45,
    expires: '31 Окт 2024',
    status: 'active',
  },
  {
    id: 2,
    code: 'WELCOME',
    discount: '15%',
    limit: '∞',
    used: 230,
    expires: 'Бессрочно',
    status: 'active',
  },
  {
    id: 3,
    code: 'VIP50',
    discount: '50%',
    limit: '10',
    used: 10,
    expires: '15 Окт 2024',
    status: 'expired',
  },
]

export const initialBanners = [
  {
    id: 1,
    title: 'Осенняя акция',
    placement: 'Главная',
    status: 'active',
    clicks: 1240,
    views: 15600,
  },
  {
    id: 2,
    title: 'Новые астрологи',
    placement: 'Каталог',
    status: 'active',
    clicks: 890,
    views: 12000,
  },
]

export const initialServices = [
  {
    id: 1,
    title: 'Натальная карта',
    price: '3 900 ₽',
    type: 'Авто-отчёт',
    active: true,
  },
  {
    id: 2,
    title: 'Соляр',
    price: '1 990 ₽',
    type: 'Авто-отчёт',
    active: true,
  },
  {
    id: 3,
    title: 'Синастрия',
    price: '2 500 ₽',
    type: 'Авто-отчёт',
    active: true,
  },
  {
    id: 4,
    title: 'Консультация видео',
    price: '5 000 ₽',
    type: 'Услуга астролога',
    active: true,
  },
]

export const initialCalendarEvents = [
  {
    id: 1,
    title: 'Солнечное затмение',
    type: 'Затмение',
    date: '25 Окт 2024',
    zodiac: 'Скорпион',
    status: 'published',
    views: '4 500',
  },
  {
    id: 2,
    title: 'Полнолуние в Тельце',
    type: 'Полнолуние',
    date: '15 Ноя 2024',
    zodiac: 'Телец',
    status: 'draft',
    views: '0',
  },
  {
    id: 3,
    title: 'Ретроградный Меркурий',
    type: 'Ретроград',
    date: '25 Ноя 2024',
    zodiac: 'Стрелец',
    status: 'published',
    views: '8 200',
  },
]
